module.exports = __webpack_public_path__ + "static/img/Complete Store.cd675206.svg";